import { createContext, useContext, useMemo, useState } from "react";

import { UnlockModal } from "@/components/upgrade-modals/unlock-modal";

export type MyFilesModalsContextValue = {
  openUnlock: () => void;
};

const Ctx = createContext<MyFilesModalsContextValue | null>(null);

export function useMyFilesModals(): MyFilesModalsContextValue {
  const ctx = useContext(Ctx);

  if (!ctx)
    throw new Error(
      "useMyFilesModals must be used within MyFilesModalsProvider",
    );

  return ctx;
}

export function MyFilesModalsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [openUnlock, setOpenUnlock] = useState(false);

  const value = useMemo(
    () => ({
      openUnlock: () => setOpenUnlock(true),
    }),
    [],
  );

  return (
    <Ctx.Provider value={value}>
      {children}
      <UnlockModal isOpen={openUnlock} onOpenChange={setOpenUnlock} />
    </Ctx.Provider>
  );
}
